export default "__VITE_ASSET__257bdb00__"